module.exports = __webpack_public_path__ + "static/media/calendar.059da4c9.svg";